<template>
  <b-card>
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="fullPage"
    ></loading>
    <b-row>
      <b-col md="4">
        <b-form-group>
          <b-form-select
            v-model="filter2"
            :options="select.filterOptions"
            required
            class="input-new"
            @change="resetFilter"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-input-group v-if="filter2 === '1'">
          <b-form-input
            v-model="form.name"
            type="text"
            id="filterInput"
            placeholder="Type to Search"
            class="input-new"
            @click="resetIndex"
          ></b-form-input>
        </b-input-group>
        <b-input-group v-if="filter2 === '2'">
          <b-form-input
            v-model="form.outlet_name"
            type="text"
            id="filterInput"
            placeholder="Type to Search"
            class="input-new"
            @click="resetIndex"
          ></b-form-input>
        </b-input-group>
        <b-input-group v-if="filter2 === '3'">
          <b-form-input
            v-model="form.date"
            type="date"
            id="filterInput"
            placeholder="Type to Search"
            class="input-new"
            @click="resetIndex"
          ></b-form-input>
        </b-input-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <b-button
            variant="primary"
            class="input-new"
            v-if="filter2 !== null"
            @click="onClickSearch"
            >SEARCH</b-button
          >
          &nbsp;&nbsp;&nbsp;
          <b-button
            variant="warning"
            class="input-new"
            v-if="filter2 !== null"
            @click="clearFilter"
            >CLEAR</b-button
          >
        </b-form-group>
      </b-col>
    </b-row>

    <!-- TABLE -->
    <b-table
      show-empty
      head-variant="dark"
      striped
      hover
      bordered
      :items="items"
      :fields="fields"
      id="my-table"
    >
      <template v-slot:cell(index)="data">
        {{ pagination.startIndex + data.index }}
      </template>
      <template v-slot:cell(action)="data">
        <span>
          <b-button
            variant="primary"
            size="sm"
            @click="onClickView(data.item.id)"
            >VIEW</b-button
          >
        </span>
      </template>
    </b-table>
    <b-pagination
      v-model="pagination.current"
      :total-rows="pagination.total"
      :per-page="pagination.perPage"
      @change="onChangePage"
      v-if="!this.isLoading"
    ></b-pagination>
  </b-card>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  data() {
    return {
      items: [],
      form: {
        user_id: this.$store.getters.getUser_id,
        name: null,
        email: null,
        date: null,
        outlet_name: null,
        page: 1
      },
      isLoading: false,
      fullPage: true,
      indexsearch: 1,
      filter2: null,
      select: {
        filterOptions: [
          { text: "Please Select", value: null },
          { text: "Name", value: "1" },
          { text: "Outlet Category", value: "2" },
          { text: "Date", value: "3" }
        ]
      },
      pagination: {
        total: 0,
        current: 1,
        perPage: 10,
        startIndex: 0
      }
    };
  },
  components: {
    Loading
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  mounted() {},
  created() {
    if (this.tab !== "2") {
      this.getDownlineStockout();
      return;
    }

    if (this.filter) {
      this.filter2 = this.filter !== "null" ? this.filter : null;
      this.pagination.current = this.page !== "null" ? this.page : null;
      this.indexsearch = this.page !== "null" ? this.page : null;
      this.form.name = this.name !== "null" ? this.name : null;
      this.form.date = this.date !== "null" ? this.date : null;
      this.form.outlet_name =
        this.outlet_name !== "null" ? this.outlet_name : null;

      if (this.filter !== "null") {
        this.onClickSearch();
      } else {
        this.pagination.current = this.page !== "null" ? this.page : null;
        this.getDownlineStockout();
      }
    } else {
      this.getDownlineStockout();
    }
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    id: {
      type: String,
      required: false
    },
    type: {
      type: String,
      required: false
    },
    state: {
      type: Number,
      required: true
    },
    filter: {
      type: String,
      default: null
    },
    page: {
      type: String
    },
    date: {
      type: String
    },
    name: {
      type: String
    },
    outlet_name: {
      type: String
    },
    tab: {
      type: String
    }
  },
  methods: {
    onClickView(id) {
      if (parseInt(this.$store.getters.getAccessLevel) === 1) {
        this.$router.push({
          path: `stockout_view_admin?id=${id}&cat=1&state=${this.state}&upline=${this.id}&type=${this.type}&page=${this.pagination.current}&filter=${this.filter2}&date=${this.form.date}&name=${this.form.name}&outlet_name=${this.form.outlet_name}&email=null`
        });
      } else {
        this.$router.push({
          path: `stockout_view_user?id=${id}&cat=1&type=${this.type}&page=${this.pagination.current}&filter=${this.filter2}&date=${this.form.date}&name=${this.form.name}&outlet_name=${this.form.outlet_name}&email=null`
        });
      }
    },
    resetFilter() {
      this.form.name = null;
      this.form.outlet_name = null;
      this.form.date = null;
    },
    clearFilter() {
      this.filter2 = null;
      this.form.name = null;
      this.form.outlet_name = null;
      this.form.date = null;
      this.getDownlineStockout();
    },
    resetIndex() {
      this.indexsearch = 1;
    },
    getDownlineStockout() {
      this.isLoading = true;
      let data = {
        user_id: this.id ? this.id : this.$store.getters.getUser_id,
        page: this.pagination.current
      };
      this.$store.dispatch("getDownlineStockout", data).then(res => {
        if (res.data.response.code === 100) {
          this.isLoading = false;
          this.items = [];
          res.data.data.data.forEach(element => {
            let outletCat;
            if (element.outlet !== null) {
              outletCat = element.outlet.name;
            }
            this.items.push({
              name: element.userdetails.name,
              date: element.date,
              outlet_name: element.outlethistory.outlet_name,
              id: element.stock_id,
              category: outletCat
            });
          });
        }
        this.pagination.total = res.data.data.total;
        this.pagination.current = res.data.data.current_page;
        this.pagination.perPage = res.data.data.per_page;
        this.pagination.startIndex = res.data.data.from;
        this.indexsearch = res.data.data.current_page;
      });
    },
    onClickSearch() {
      this.isLoading = true;
      this.form.page = this.indexsearch;
      this.form.user_id = this.id ? this.id : this.$store.getters.getUser_id;

      if (this.filter2 === null) {
        this.getDownlineStockout();
      } else {
        this.$store.dispatch("searchDownlineStockout", this.form).then(res => {
          this.isLoading = false;
          this.items = [];
          if (res.data.response.code === 100) {
            this.isLoading = false;
            res.data.data.data.forEach(element => {
              let outletCat;
              if (element.outlet !== null) {
                outletCat = element.outlet.name;
              }
              this.items.push({
                name: element.userdetails.name,
                date: element.date,
                outlet_name: element.outlethistory.outlet_name,
                id: element.stock_id,
                category: outletCat
              });
            });
          }
          this.pagination.total = res.data.data.total;
          this.pagination.current = res.data.data.current_page;
          this.pagination.perPage = res.data.data.per_page;
          this.pagination.startIndex = res.data.data.from;
          this.indexsearch = res.data.data.current_page;
        });
      }
    },
    onChangePage(index) {
      this.pagination.current = index;
      if (this.filter2 === null) {
        this.getDownlineStockout();
      } else {
        this.indexsearch =
          this.pagination.current !== this.indexsearch
            ? this.pagination.current
            : this.indexsearch++;
        this.onClickSearch();
      }
    }
  }
};
</script>
<style lang="css" scoped></style>
